export const environment = {
    webappsRootURL: 'https://project2apps.epa.ohio.gov',
    ebizRootURL: 'https://epaproject2apps.epa.ohio.gov',
    clientID : '2369c162-e93a-41db-aa5d-93d1b3a35446', 
    redirectURI: 'https://stars.project2.epa.ohio.gov', 
};